export class RatingTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      rating: obj.attributes.rating,
      notes: obj.attributes.notes,
      createdBy: obj.attributes.created_by
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ratings/rating.transformer.js